export default function () {
    const mobileNavToggles = document.querySelectorAll('.mobile-nav-toggle');
    const navs = document.querySelectorAll('.nav');
    const topBars = document.querySelectorAll('.top-bar');

    mobileNavToggles.forEach((toggle) => {
        toggle.addEventListener('click', function () {
            this.classList.toggle('active');

            navs.forEach((nav) => {
                nav.classList.toggle('mobile-active');
            });

            topBars.forEach((topBar) => {
                topBar.classList.toggle('mobile-active');
            });
        });
    });
}